import ModalDrag from 'component/ModaDrag/ModalDrag'
import { Button, Col, ConfigProvider, Input, message, Pagination, Row, Table} from 'antd'
import {SearchOutlined,} from '@ant-design/icons'
import React, { useEffect, useReducer, useRef, useState } from 'react'
import GlobalCss from '@/global.module.less'
import css from './add-dataset-to-task.module.less'
import { sendHttpPostRequest } from '../../../api/http-request'
import SearchInput from './SearchInput/SearchInput'
import idataCourseTableStyles from "../../common/global-styles/idatacourse-table.module.less";
import zhCN from 'antd/lib/locale/zh_CN';

function MountDatasetToTaskModal(props: any) {
  const { open, setOpen, actionCallback, exercise } = props
  const query = useRef('')
  const page = useRef(1)
  const pageSize = useRef(10)
  const [total, setTotal] = useState(0)
  const [datasource, setDatasource] = useState([])
  const [rowSelectedKeys, setRowSelectedKeys] = useState([])

  const onOk = () => {
    let data = {
      exercise_id: exercise?.id,
      dataset_id_list: JSON.stringify(rowSelectedKeys),
    }

    sendHttpPostRequest(
      'exercise/api/oam_mount_public_datasets/',
      data,
      (res) => {
        if (res.code == 0) {
          message.success('挂载成功~')
          setRowSelectedKeys([])
          query.current = ''
          page.current = 1
          actionCallback && actionCallback()
        } else {
          message.error(res.message)
        }
      }
    )

    setOpen(false)
  }

  const onCancel = () => {
    setRowSelectedKeys([])
    setOpen(false)
    query.current = ''
    page.current = 1
  }

  const getDatasetList = () => {
    let data = {
      query: query.current,
      page: page.current,
      pagesize: pageSize.current,
      dataset_type: '2',
    }
    sendHttpPostRequest('dataset/api/oam_query_dataset_list/', data, (res) => {
      if (res.code == 0) {
        setDatasource(res.query_list)
        setTotal(res.total_sum)
      }
    })
  }

  useEffect(() => {
    getDatasetList()
    return () => {}
  }, [])

  const tableRowSelection = {
    selectedRowKeys: rowSelectedKeys,
    getCheckboxProps: (record: any) => ({
      disabled: exercise?.mounted_datasets.some(
        (item) => record.id == item.dataset_id
      ),
    }),
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setRowSelectedKeys(selectedRowKeys)
    },
  }
  const onPageChange = (np, nps) => {
    page.current = np
    pageSize.current = nps
    getDatasetList()
  }



  const cols = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '80px',
    },
    {
      title: '数据集名称',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 100,
      ellipsis: true,
      align: 'center',
      fixed: 'right',
      render: (text: any, record: any) => {
        return (
          <Button
            //className={courseCreateStyles.modalBtn}
            type="default"
            size="small"
            style={{margin:'0px 10px',height: 28, width: 60, textShadow:'none', boxShadow:'none' }}
            onClick={()=>{window.open('/oam_dataset_detail?id=50455' + record.id)}}
          >
            预览
          </Button>
        )
      },
    },
  ]

  const AddDatasetToTaskModalContent = (
    <div style={{marginTop:-16}}>
      <div style={{float:'right'}}>
        <Input
          onPressEnter={() => {
            page.current = 1
            getDatasetList()
          }}
          placeholder="搜索数据集"
          onChange={(e) => {
            query.current = e.target.value
          }}
          style={{ borderRadius: 20, width: 300, marginBottom: 10 }}
          suffix={<SearchOutlined style={{ color: '#666666' }} />}
        />
      </div>
      <div style={{height:550}} className={idataCourseTableStyles.tableWrapper}>
        <Table
          dataSource={datasource}
          columns={cols}
          pagination={false}
          rowKey={(r) => r.id}
          rowSelection={tableRowSelection}
        />
      </div>
      <ConfigProvider locale={zhCN}>
          <div style={{textAlign: 'center'}} className={"css.pagination"} >
              <Pagination
                  defaultCurrent={1}
                  total={total}
                  defaultPageSize={10}
                  hideOnSinglePage={true}
                  current={page.current}
                  onChange={onPageChange}
                  showQuickJumper={false}
                  showSizeChanger={false}
                  //showTotal={total => `共 ${total} 数据集`}
                  //pageSizeOptions={["10","20","50","100"]}
              />
          </div>
      </ConfigProvider>
    </div>
  )

  return (
    <ModalDrag
      width={800}
      modalTitle={'添加数据集'}
      modalContent={AddDatasetToTaskModalContent}
      open={open}
      onCancel={() => setOpen(false)}
      footer={

          <div style={{textAlign: 'center'}}>
            <Button type="default" onClick={onCancel} style={{textShadow:'none',  boxShadow:'none',}}>
              取消
            </Button>
            <Button onClick={onOk} type="primary" style={{textShadow:'none',  boxShadow:'none', marginLeft: '50px' }}>
              确定
            </Button>
          </div>
      }
    />
  )
}

export default MountDatasetToTaskModal
